import { Children, type ReactNode } from 'react'
import cx from 'classnames'
import styles from './AvatarStrip.module.css'

export interface AvatarStripProps {
  children?: ReactNode
}

/**
 * Displays avatars overlapping each other.
 * Use Avatar components as children with `ring` set to `true`.
 */
export function AvatarStrip({ children }: AvatarStripProps) {
  return (
    <div className={cx(styles.root)}>
      {Children.map(children, (c, i) => (
        <div className={styles.item} key={i}>
          {c}
        </div>
      ))}
    </div>
  )
}
